import { useParams } from "react-router-dom";
import { useGetInfo } from "./useGetInfo";
import { useEffect, useState } from "react";

export const useGetCheckoutPaymentProviders = () => {
  const params = useParams();
  const store_id = params?.store_id;
  const { getStoreInfo } = useGetInfo();
  const storeDetails = getStoreInfo(store_id);
  const [allowedPaymentProviders, setAllowedPaymentProviders] = useState([]);

  useEffect(() => {
    const paymentProviders = [];

    // Raven
    if (storeDetails?.support_raven_payment_on_checkout_flow)
      paymentProviders.push("raven");

    // Moniepoint
    if (
      storeDetails?.terminals?.find(
        (terminal) =>
          terminal?.use_on_checkout && terminal?.terminal_type === "MONIEPOINT",
      )
    )
      paymentProviders.push("moniepoint");

    // Kuda
    if (
      storeDetails?.terminals?.find(
        (terminal) =>
          terminal?.use_on_checkout && terminal?.terminal_type === "KUDA",
      )
    )
      paymentProviders.push("kuda");

    // Opay
    paymentProviders.push("opay");

    // Interswitch
    paymentProviders.push("interswitch");

    setAllowedPaymentProviders(paymentProviders);
  }, []);

  return {
    hasAtleastOneProvider: allowedPaymentProviders?.length > 0,
    allowedPaymentProviders,
    setAllowedPaymentProviders,
  };
};
